/**
 * LBank Exchange Metadata
 */

import { LBANK_WS_CHANNELS, LBANK_WS_TOPOLOGY } from './ws';

import type { ExchangeId } from '../../lib/types';

export const LBANK_METADATA = {
  id: 'lbank' as ExchangeId,
  restDocs: [
    'https://www.lbank.com/docs/#depth-information',
    'https://www.lbank.com/docs/#recent-transactions-list',
    'https://www.lbank.com/docs/#query-k-bar-data',
    'https://www.lbank.com/docs/#trading-pairs',
  ],
  wsDocs: [
    'https://www.lbank.com/docs/#request-amp-subscription-instruction',
    'https://www.lbank.com/docs/#market-depth',
  ],
  wsTopology: LBANK_WS_TOPOLOGY,
  wsChannels: LBANK_WS_CHANNELS,
  notes: [
    'Plain JSON WebSocket messages (no compression).',
    'Server sends ping, client must respond pong within 1 minute.',
    'Orderbook sends full snapshots (not incremental).',
    'Symbol format: lowercase underscore (btc_usdt).',
    'Internal API supports 8h/12h intervals; public API does not.',
  ],
} as const;
